import { default as _Vue } from 'vue';
import { Store } from 'vuex';

// Repository protocols
import SocketRepository, { TOptions as TOptionsSocket } from '@/plugins/podolib/services/repository/SocketRepository';
import { AbstractService } from '@/plugins/podolib/lib/AbstractService';

// Service options type
export type TOptions = {
  type: 'socket' | 'iot';
  options?: TOptionsSocket; // Todo : add iot
};

export type TRepositoryState = {};

export interface RessourceQuery {
  [index: string]: any;
  create: {
    ressource: string;
    data: any;
  };
  fetch: {
    ressource: string;
    params: any;
  };
  get: {
    ressource: string;
    identifier: string;
    params: any;
  };
  patch: {
    ressource: string;
    params: any;
    data: any;
    additionnalQuery?: object;
  };
  delete: {
    ressource: string;
    identifier: any;
  };
}

export const CRUD_OPERATIONS = ['fetch', 'create', 'patch', 'delete', 'get'];

export default class RepositoryService extends AbstractService<TOptions, any> {
  private _socket: SocketRepository<TRepositoryState> | undefined;
  private _currentCommandId?: string;
  public createRessource!: (query: RessourceQuery['create']) => any;
  public fetchRessource!: (query: RessourceQuery['fetch']) => any;
  public getRessource!: (query: RessourceQuery['get']) => any;
  public patchRessource!: (query: RessourceQuery['patch']) => any;
  public deleteRessource!: (query: RessourceQuery['delete']) => any;
  // private readonly _iot: IotRepository<TRepositoryState> | undefined;

  /**
   * @param options
   */
  constructor(options: TOptions) {
    super(options, 'repository');
  }

  /**
   * Initialize plugin
   */
  async init(Vue: typeof _Vue, store: Store<TRepositoryState>) {
    await super.init(Vue, store);

    switch (this.options.type) {
      case 'socket':
        this._socket = new SocketRepository<TRepositoryState>(this.Vue, this.store, this.logger, this.options.options!);
        break;
      case 'iot':
        /*this.socket = new RepositoryIot<TRepositoryState>(
          this.Vue,
          this.store,
          this.options.options!
        );*/
        break;
      default:
        console.error('Repository type is required');
        process.exit();
    }

    // Expose ressource operation methods (fetchRessource / deleteRessource / patchRessource / createRessource)
    for (let operationName of CRUD_OPERATIONS) {
      (<any>this)[`${operationName}Ressource`] = (query: RessourceQuery) => {
        return (<any>this)[this.options.type][`${operationName}Ressource`](query);
      };
    }
  }

  get socket(): SocketRepository<TRepositoryState> | undefined {
    return this._socket;
  }

  public emit(type: string, service: string, ...args: any) {
    return (<any>this)[this.options.type].emit(type, service, ...args);
  }

  public emitCommand(command: string, data: any) {
    return (<any>this)[this.options.type].emitCommand(command, data);
  }

  /*emitCustom(...query: any[]) {
    return (<any>this)[this.options.type].emitCustom(query);
  }*/

  public setCurrentCommandId(commandId: string) {
    console.log(commandId);
    this._currentCommandId = commandId;
  }

  async removeCommands() {
    const commands = this.Vue.prototype.$pdc.entities!.commands.storedEntity.list;
    if (commands.length) {
      for (const command of commands) {
        return (<any>this)[this.options.type].deleteCommand(command._id);
      }
    } else {
      return;
    }
  }
  /*get iot(): RepositoryIot<TRepositoryState> | undefined {
    return this._iot;
  }*/
}
